// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var AssignShippingAddressController = function ($scope, $modalInstance, Customer, Contract, AdditionalAddresses, Modal, gettext, gettextCatalog, CountryList, CountryWhiteListSettings) {
    $scope.Contract = Contract;
    $scope.Modal = Modal;
    $scope.countries = [];
    $scope.states = [];
    $scope.displayedCountries = [];
    $scope.CountryWhiteListSettings = {};

    if (AdditionalAddresses)
        $scope.AdditionalAddresses = AdditionalAddresses;
    else
        $scope.AdditionalAddresses = [];

    loadCountries();

    function loadCountries() {
        CountryList.getCountries().then(function (response) {
                $scope.countries = response.data.slice();
                loadWhiteListCountries()
            },
            function () {
                $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
            });
    }

    function setDisplayedCountries() {
        let availableCountries = $scope.countries.filter(function (country) {
            return $scope.CountryWhiteListSettings.CountryWhiteList.some(function (countryFromWhitelist) {
                return country.TwoLetterCode === countryFromWhitelist.TwoLetterCode && country.TwoLetterCode;
            });
        });
        $scope.displayedCountries = $scope.displayedCountries.concat(availableCountries);
    }

    function loadWhiteListCountries() {
        CountryWhiteListSettings.get($scope.locale).then(function (response) {
            $scope.CountryWhiteListSettings = response.data;
            if ($scope.CountryWhiteListSettings.IsEnabled) {
                setDisplayedCountries();
                if (!$scope.isCustomerCountryInWhiteList($scope.customer.Address.Country)) {
                    let customerCountry = $scope.countries.find(function (countryCode) {
                        return countryCode.TwoLetterCode === $scope.customer.Address.Country;
                    });
                    $scope.displayedCountries.push(customerCountry);
                }
            } else {
                $scope.displayedCountries = $scope.countries;
            }
        }, function () {
            $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
        });
    }

    $scope.isAddressAssigned = function () {
        return AdditionalAddresses.some(x => x.Id === $scope.Contract.ShippingAddressId);
    }

    $scope.getAdditionalAddressFormat = function (additionalAddress){
        const array = [];
        if (additionalAddress.FirstName){
            var text = additionalAddress.FirstName;
            if (additionalAddress.LastName) {
                text += " " + additionalAddress.LastName;
            }
            array.push(text);
        }
        if(additionalAddress.Street) {
            var text = additionalAddress.Street;
            if (additionalAddress.HouseNumber) {
                text += " " + additionalAddress.HouseNumber;
            }
            array.push(text);
        }
        if(additionalAddress.City) array.push(additionalAddress.City);
        if(additionalAddress.PostalCode) array.push(additionalAddress.PostalCode);
        if(additionalAddress.Country) array.push(additionalAddress.Country);
        return array.join("\n");
    }

    $scope.addEditAdditionalAddress = function (additionalAddress) {
        var item = additionalAddress ? additionalAddress : {};
        var modalInstance = Modal.open({
            templateUrl: '/partials/controls/additional-address-dialog.html' + itero.linkVersion,
            controller: AdditionalAddressController,
            windowClass: "fade in",
            resolve: {
                CustomerId: function () {
                    return $scope.Contract.CustomerId;
                },
                AdditionalAddresses: function () {
                    return $scope.AdditionalAddresses;
                },
                AdditionalAddress: function () {
                    return item;
                },
                CountryWhiteListSettings: function () {
                    return $scope.CountryWhiteListSettings;
                },
                IsExistingCustomer : function (){
                    return true;
                },
                DisplayedCountries: function (){
                    return $scope.displayedCountries;
                }
            }
        });

        modalInstance.result.then(function (result) {
            if (result) {
                if (!additionalAddress) $scope.customer.AdditionalAddresses.push(item);
                Object.assign(item, result);
            }
        });
    };

    $scope.removeAdditionalAddress = function (additionalAddress) {
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete Additional Address')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function () {
                $scope.customer = new Customer();
                $scope.customer.AdditionalAddresses = $scope.AdditionalAddresses.filter(function (_) {
                    return _ !== additionalAddress
                });
                $scope.customer.$patchUpdate({ customerId: $scope.Contract.CustomerId }).then(function () {
                    $scope.AdditionalAddresses = $scope.AdditionalAddresses.filter(function (_) {
                        return _ !== additionalAddress
                    })
                });
            });
    }

    $scope.assignShippingAddress = function (additionalAddress) {
        $scope.yesCancel(gettextCatalog.getString(gettext('Assign Shipping Address')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function () {
                $scope.Contract.ShippingAddressId = additionalAddress.Id;
                $scope.Contract.$patchUpdate({ contractId: $scope.Contract.Id });
            });
    }

    $scope.unassignShippingAddress = function () {
        $scope.yesCancel(gettextCatalog.getString(gettext('Unassign Shipping Address')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function () {
                $scope.Contract.ShippingAddressId = "";
                $scope.Contract.$patchUpdate({ contractId: $scope.Contract.Id });
            });
    }

    $scope.canAddAdditionalAddress = function () {
        return $scope.AdditionalAddresses.length < 5;
    }

    $scope.close = function () {
        $modalInstance.close();
    };
};
AssignShippingAddressController.$inject = ['$scope', '$uibModalInstance', 'Customer', 'Contract', 'AdditionalAddresses', 'Modal', 'gettext', 'gettextCatalog', 'CountryList', 'CountryWhiteListSettings'];
